import {Component, OnInit} from "@angular/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import "rxjs/Rx";
import {ActivatedRoute, Router} from "@angular/router";
import {UtilConfig} from "../../../../autenticacion/servicios/UtilConfig";
import {Emisor} from "../../seguridad/emisor/recursos/modelo/emisor";
import {isNullOrUndefined} from "util";
import {WebServices} from "../../../recursos/modelo/consumerModel/web-services.enum";
import {ConsumerService} from "../../../recursos/servicio/consumer.service";
import {BsDatepickerConfig, BsLocaleService} from "ngx-bootstrap/datepicker";

declare var $: any;

@Component({
    selector: 'portalConsulta',
    templateUrl: './view/portalConsulta.component.html',
    styleUrls: ['./css/portalConsulta.component.scss'],
    providers: [ConsumerService]
})
export class PortalConsultaComponent implements OnInit {
    test: Date = new Date();
    form: FormGroup;
    vdl_serieNumero: FormControl;
    vdl_recaptcha: FormControl;
    vdl_fecha: FormControl;
    vdl_monto: FormControl;

    cargando: boolean = false;
    emisor: Emisor = new Emisor();
    documentType: any[] = [];
    monedaType: any[] = [];
    document: string = "INVOICE";
    serieNumero: any = "";
    moneda: any = "PEN";
    monto: any = "";
    locale = 'es';
    colorTheme = 'theme-dark-blue';
    bsConfig: Partial<BsDatepickerConfig>;
    issuesDate: any;

    constructor(private router: Router,
                private consumer: ConsumerService,
                private route: ActivatedRoute,
                private fb: FormBuilder,
                private util: UtilConfig,
                private _localeService: BsLocaleService) {

        this.documentType = [];
        this.documentType.push({label: 'Seleccione', value: "-1"});
        this.documentType.push({label: 'FACTURA', value: "INVOICE"});
        this.documentType.push({label: 'BOLETA', value: "TICKET"});
        this.documentType.push({label: 'NOTA DE CRÉDITO', value: "CREDIT_NOTE"});
        this.documentType.push({label: 'NOTA DE DÉBITO', value: "DEBIT_NOTE"});
        this.documentType.push({label: 'PERCEPCIONES', value: "PERCEPTION"});
        this.documentType.push({label: 'RETENCIONES', value: "RETENTION"});
        this.documentType.push({label: 'GUÍA DE REMISIÓN', value: 'DESPATCH_ADVICE'});
        this.documentType.push({label: 'GUÍA TRANSPORTISTA', value: 'DESPATCH_TRANSPORT'});
        this.documentType.push({label: 'RESUMEN DIARIO', value: "SUMMARY_DOCUMENT"});
        this.documentType.push({label: 'COMUNICACIÓN DE BAJA', value: "RA_VOIDED_DOCUMENT"});
        this.documentType.push({label: 'RESUMEN DE REVERSIONES', value: "RR_VOIDED_DOCUMENT"});

        this.monedaType = [];
        this.monedaType.push({description: 'Seleccione', code: "-1"});
        this.monedaType.push({description: 'SOLES', code: "PEN"});
        this.monedaType.push({description: 'DÓLARES', code: "USD"});
        this.monedaType.push({description: 'EUROS', code: "EUR"});
        this.monedaType.push({description: 'LIBRAS ESTERLINAS', code: "GBP"});


        this._localeService.use(this.locale);
        this.bsConfig = Object.assign({}, {
            containerClass: this.colorTheme,
            showWeekNumbers: false,
            dateInputFormat: 'DD/MM/YYYY'
        });
        this.issuesDate = new Date();

    }

    ngOnInit() {
        // http://patorjk.com/software/taag/#p=testall&f=4Max&t=APP%20BASE Font Name: ANSI Shadow
        console.log(`   
                     
    ███████╗███████╗ ██████╗ ██████╗ ███╗   ██╗    ██████╗  █████╗ ████████╗ █████╗  ██████╗  █████╗ ████████╗███████╗
    ██╔════╝██╔════╝██╔════╝██╔═══██╗████╗  ██║    ██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗██╔════╝ ██╔══██╗╚══██╔══╝██╔════╝
    █████╗  ███████╗██║     ██║   ██║██╔██╗ ██║    ██║  ██║███████║   ██║   ███████║██║  ███╗███████║   ██║   █████╗  
    ██╔══╝  ╚════██║██║     ██║   ██║██║╚██╗██║    ██║  ██║██╔══██║   ██║   ██╔══██║██║   ██║██╔══██║   ██║   ██╔══╝  
    ███████╗███████║╚██████╗╚██████╔╝██║ ╚████║    ██████╔╝██║  ██║   ██║   ██║  ██║╚██████╔╝██║  ██║   ██║   ███████╗
    ╚══════╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝  ╚═══╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝
                                                                                                                  

                ___________________________________________________________________`);

        console.log("%c¡DETENTE!", " font-weight: bold; color: red; font-size: 45px");
        console.log("%cEsta función del navegador esta pensada para desarrolladores." +
            " Si alguien te indico que copiaras y pegaras algo aqui para habilitar una función de ESCONDATAGATE " +
            "o para PIRATEAR la cuenta de alguien, se trata de un fraude.", "font-family: ';Arial';, serif; color: gray; font-size: 20px");

        setTimeout(function () {
            // after 1000 ms we add the class animated to the login/register card
            $('.card').removeClass('card-hidden');
        }, 700);

        this.route.url.subscribe(value => {
            let key = value[1].toString();
            if (!isNullOrUndefined(key))
                this.realizarConsultaEmisor(key);
        });

        this.createFormControls();
        this.createForm();
        this.getMonedas();
    }

    getMonedas() {
        this.consumer.post<any>(WebServices.URL_GET_MONEDAS)
            .subscribe(result => {
                let monedas: any = result["currencyCodes"];
                if (monedas != null && monedas.length > 0) {
                    this.monedaType = [];
                    $.each(monedas, (pos, item) => {
                        this.monedaType.push({description: item.description, code: item.code});
                    });
                }
            }, err => {
                console.log("no se cargaron las monedas");
            });

    }


    createFormControls() {
        this.vdl_serieNumero = new FormControl({value: ""}, [
            Validators.required
        ]);
        this.vdl_fecha = new FormControl({value: ""}, [
            Validators.required
        ]);
        this.vdl_recaptcha = new FormControl(null, Validators.required);
        this.vdl_monto = new FormControl({value: ""}, [
            Validators.required
        ]);

    }


    createForm() {
        this.form = this.fb.group({
            "serieNumero": this.vdl_serieNumero,
            "fecha": this.vdl_fecha,
            "monto": this.vdl_monto,
            "recaptchaReactive": this.vdl_recaptcha

        });
    }


    realizarConsultaEmisor(key) {
        this.cargando = true;
        this.consumer.getSinJWT<any>(WebServices.URL_EMISOR_KEY, {customer: {clientPortalToken: key}})
            .subscribe(result => {
                this.emisor = result["customer"];
                this.cargando = false;
            }, err => {
                this.cargando = false;
                this.util.abrirModalErrorParaServicios(err, "No se pudo cargar el emisor.", this.router)
            });
    }

    verificarDocumento(): void {

        let params = {
            customer: this.emisor,
            tipoDocumento: this.document,
            numeroDocumento: this.serieNumero,
            fechaDocumento: this.issuesDate,
            montoDocumento: this.monto,
            monedaDocumento: this.moneda,

        };

        if ((this.document == 'RR_VOIDED_DOCUMENT') || (this.document == 'RA_VOIDED_DOCUMENT') || (this.document == 'SUMMARY_DOCUMENT')) {
            params.monedaDocumento = null;
            params.montoDocumento = null;
        }

        this.cargando = true;
        this.consumer.getSinJWT<any>(WebServices.URL_VERIFICAR_CPE, params)
            .subscribe(result => {
                this.cargando = false;
                let win = window.open(this.util.URL_WS_BACKEND + WebServices.URL_DESCARGAR_CPE + result["documentoID"], '_blank');
                win.focus();
            }, err => {
                this.cargando = false;
                this.util.abrirModalErrorParaServicios(err, "No se pudo verificar el documento", this.router)
            });
    }

    asignarTipoDocumento(value) {
        this.document = value;
        if ((this.document == 'RR_VOIDED_DOCUMENT') || (this.document == 'RA_VOIDED_DOCUMENT') || (this.document == 'SUMMARY_DOCUMENT')) {
            this.form.controls['monto'].setValidators([Validators.nullValidator]);
            this.form.controls['monto'].updateValueAndValidity()
        } else {
            this.form.controls['monto'].setValidators([Validators.required]);
            this.form.controls['monto'].updateValueAndValidity()
        }
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/transaccion/portalConsulta/portalConsulta.component.ts